import { Box, Tab, Tabs } from '@mui/material';
import React, { useLayoutEffect, useMemo } from 'react';
import { useAppSelector } from '../../store';
import { useTranslation } from 'react-i18next';
import ShowContainer from '../material-ui/ShowContainer';

/** 
  @description при использовании не забывать добавлять key у компонента ниже
 */
export default function TabsLanguage({
  lang,
  setLang,
  defaultLang,
  component,
  myLanguage = [],
  goTo
}) {
  const { t } = useTranslation();
  const languages = useAppSelector((state) => state.info.casinoLanguages);
  const handleChange = (_, newValue) => setLang?.(newValue);

  const languageTabs = useMemo(() => {
    if (!myLanguage.length) return languages;

    return languages.filter((lang) => myLanguage.includes(lang.lang));
  }, [languages, myLanguage]);

  useLayoutEffect(() => {
    if (lang) return;
    setLang?.(defaultLang || languageTabs[0].lang);
  }, [lang]);

  return (
    <ShowContainer condition={lang}>
      <Box mt={1} sx={{ backgroundColor: (theme) => theme.palette.grey[100], width: '100%' }}>
        <Tabs
          value={lang}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ maxWidth: '95svw', minHeight: '40px' }}
          allowScrollButtonsMobile>
          {languageTabs.map((tab) => {
            return (
              <Tab
                label={tab.label}
                sx={{ minHeight: '40px' }}
                value={tab.lang}
                key={tab.lang}
                component={component}
                to={goTo?.(tab)}
              />
            );
          })}
        </Tabs>
      </Box>
    </ShowContainer>
  );
}
